import LessonCard from '@components/student-dashboard/course-modules/lesson-card'
import { MODULE_STATE } from '@lib/constants/course-modules'
import { LessonType, ModuleType } from '@lib/types/course-modules'

type Props = {
  showLessons: boolean
  moduleState: ModuleType['state']
  lessons: ModuleType['lessons']
  isOnDashboard: boolean
  isOnCoursePage?: boolean
}
const ModuleAllLessons = ({
  showLessons,
  moduleState,
  lessons,
  isOnDashboard,
  isOnCoursePage,
}: Props) => {
  // A lesson can span multiple classes (e.g. partially completed - continue in
  // next class), so number by distinct lesson rather than by class position.
  const lessonNumberById = new Map<LessonType['id'], number>()
  lessons.forEach((lesson) => {
    if (!lessonNumberById.has(lesson.id))
      lessonNumberById.set(lesson.id, lessonNumberById.size + 1)
  })

  return (
    // grid 0fr -> 1fr animates to the content's own height, so there is nothing to
    // measure and it stays correct when the lesson list reflows.
    <div
      className="grid transition-all duration-300"
      style={{ gridTemplateRows: showLessons ? '1fr' : '0fr' }}
    >
      <div className="overflow-hidden">
        <div className="flex flex-col mt-5">
          {lessons.map((lesson, index) => (
            <LessonCard
              key={index}
              lesson={lesson}
              lessonNumber={lessonNumberById.get(lesson.id)}
              moduleState={moduleState}
              isOnDashboard={isOnDashboard}
              isOnCoursePage={isOnCoursePage}
            />
          ))}
        </div>
        {(moduleState === MODULE_STATE.ONGOING || isOnDashboard) && (
          <p className="border-t border-grey-400 pt-5 text-lg text-orange">
            That’s all the lessons!
          </p>
        )}
      </div>
    </div>
  )
}

export default ModuleAllLessons
